// Pure helpers and schema-mirroring constants for Jet onboarding step events.
// Shared by useOnboardingStepEvents (builder funnels) and useStandaloneStepEvents
// (games / CRM custom pages).

// Numeric values matching analytics.js OnboardingStepTypeEnum
export const STEP_TYPE = {
	QUESTION: 1,
	LOADER: 2,
	CONFIRM: 3,
	OTHER: 4,
}

// Numeric values matching analytics.js OnboardingPopupDoneEnum
export const POPUP_CLOSE_TYPE = {
	CLOSE_BUTTON: 1,
	OFF_SCREEN_CLICK: 2,
	ANSWER_CLICK: 3,
	OTHER: 4,
}

export const JET_STEP_STATE_KEY = 'jet_last_step'

export function formatTitle(name) {
	if (!name) return ''
	return name
		.replace(/([a-z0-9])([A-Z])/g, '$1_$2')
		.replace(/[-\s]+/g, '_')
		.toUpperCase()
		.replace(/^ONBOARDING_/, '')
		.replace(/_SCREEN$/, '')
		.replace(/_DONE$/, '')
}

export function jetGenerateStepId(title) {
	const ts = Date.now()
	const str = `${window.deviceId || ''}${title}${ts}`
	let hash = 5381
	for (let i = 0; i < str.length; i++) {
		hash = (((hash << 5) + hash) ^ str.charCodeAt(i)) >>> 0
	}
	return hash.toString(16) + ts.toString(36)
}

export function jetComputeSecondsOnScreen(showTimestamp) {
	return showTimestamp ? Math.ceil((Date.now() - showTimestamp) / 1000) : null
}

export function persistStepState(stepId, title) {
	try {
		sessionStorage.setItem(JET_STEP_STATE_KEY, JSON.stringify({ stepId, title }))
	} catch {
		/* ignore */
	}
}

export function readPersistedStepState() {
	try {
		return JSON.parse(sessionStorage.getItem(JET_STEP_STATE_KEY)) || null
	} catch {
		return null
	}
}
